export default __webpack_public_path__ + "static/media/vae5.dd1d9795.png";